const IMGS = [
  {
    src: "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/i0n8909x_Front%20view_V1.png",
    alt: "Aeonyx Life Sciences device — front view",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/cout2qqk_Left%20view.png",
    alt: "Aeonyx Life Sciences device — left perspective view",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/pqfrncfa_Top%20view.png",
    alt: "Aeonyx Life Sciences device — top view",
  },
];

export default function ProductGallery() {
  return (
    <section
      data-testid="product-gallery"
      className="bg-cool-white pb-6"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {IMGS.map((im, i) => (
            <div
              key={i}
              className="reveal group relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#8A97A8]/25 bg-[#0a2544] shadow-[0_20px_50px_-30px_rgba(2,47,107,0.35)]"
            >
              <img
                src={im.src}
                alt={im.alt}
                className="absolute inset-0 h-full w-full object-contain transition-transform duration-700 group-hover:scale-[1.06]"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
